/**
 * Per-route document titles.
 *
 * Until now every route rendered the same <title> from index.html, so a
 * visitor with four AlphaGrade tabs open saw four identical ones, and every
 * indexable page competed for the same search snippet. Flagged in the
 * 2026-09-02 site audit; this closes it.
 *
 * The homepage deliberately keeps its offer-first title. That wording is what
 * ad traffic and social unfurls land on (3627292) and is not a generic label
 * to be "fixed" into "Home".
 *
 * Longest-prefix wins, so '/alpha/memory' must be tested before '/alpha'.
 * Kept as a plain function rather than a routing table so LoginGate, which
 * renders its logged-out screens OUTSIDE the Router, can use it too.
 */

const SUFFIX = 'AlphaGrade';
export const DEFAULT_TITLE = `Grade any stock free | ${SUFFIX}`;

// Order matters: first match wins, so deeper paths come first.
const TITLES = [
  ['/alpha/memory', 'Alpha Memory'],
  ['/alpha', 'Alpha Workspace'],
  ['/admin', 'Admin'],
  ['/trends', 'Market Trends'],
  ['/correlations', 'Correlations'],
  ['/research', 'Market Research'],
  ['/screener', 'Stock Screener'],
  ['/grade-watch', 'Grade Alerts'],
  ['/watchlists', 'Watchlists'],
  ['/news', 'News on your names'],
  ['/model-portfolios', 'Model Portfolios'],
  ['/portfolio', 'Portfolio Analysis'],
  ['/energy', 'Macro Energy'],
  ['/pricing', 'Pricing'],
  ['/glossary', 'Investing Glossary'],
  ['/faq', 'FAQ'],
  ['/how-it-works', 'How the scores work'],
  ['/contact', 'Contact'],
  ['/privacy', 'Privacy Policy'],
  ['/terms', 'Terms of Service'],
  ['/sms-alerts', 'Text Alerts (SMS)'],
];

export function titleForPath(pathname) {
  const path = pathname || '/';
  if (path === '/' || path === '') return DEFAULT_TITLE;
  const hit = TITLES.find(([prefix]) => path.startsWith(prefix));
  return hit ? `${hit[1]} | ${SUFFIX}` : DEFAULT_TITLE;
}

/** Set document.title for a path. Safe to call anywhere. */
export function applyTitle(pathname) {
  try {
    document.title = titleForPath(pathname);
  } catch {
    // document may be unavailable in a non-browser context; ignore.
  }
}
